import { Button } from '@mui/material';
import { H2, Body1 } from '../../themes/typography';

const styles = {
    feedbackEventSection: {
        width: '100vw',
        height: '49.248vh' /* 360px */,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2%',
        backgroundColor: '#11203A',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)'
    },
    feedbackEventContainer: {
        width: '73.56%' /* 1130px */,
        height: '83.33%' /* 300px */,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        background: 'linear-gradient(to top left, #0A1528, #1D3A6E)',
        borderRadius: '25px'
    },
    feedbackHeader: {
        width: 'auto' /* 447px */,
        height: 'auto' /* 82px */,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center'
    },
    feedbackDescription: {
        width: '70%',
        height: '21.66%' /* 65px */,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        padding: '20px 0px'
    },
    feedbackAction: {
        width: 'auto',
        height: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
};

export default function Feedback() {
    return (
        <div style={styles.feedbackEventSection}>
            <div style={styles.feedbackEventContainer}>
                <div style={styles.feedbackHeader}>
                    <H2 color="#F8A21E">We value your feedback!</H2>
                </div>
                <div style={styles.feedbackDescription}>
                    <Body1 color="white">
                        Your insights help us improve. Share your thoughts and make shmooz even
                        better!
                    </Body1>
                </div>
                <div style={styles.feedbackAction}>
                    <Button variant="main" href='/pages/contact-us'>
                        Give Feedback
                    </Button>

                </div>
            </div>
        </div>
    );
}
